import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import GochiMenuDetailShop from './GochiMenuDetailShop';
import RemoveGochiKidDialog from '../../components/molecules/RemoveGochiKidDialog';
import ProgressDialog from '../../components/molecules/ProgressDialog';
// import DetailTextButton from '../../components/atoms/DetailTextButton';
import RemoveGochiKidTextButton from '../../components/atoms/RemoveGochiKidTextButton';
import AddGochiKidDialogShop from '../../components/molecules/AddGochiKidDialogShop';
import {
  getGochiMenus,
  getGochiMenuDetail,
  removeGochiKidMenu,
  addGochiKidMenu
} from '../../actions/GochiMenus';
import { sendLogin } from '../../auth/Auth';
import listMenuChildTypes from '../../constants/MenuChildType';
import MenuRegisterButtonShop from '../../components/atoms/MenuRegisterButtonShop';

const styles = {
  scrollTable: {
    maxHeight: 375,
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  lstMenu: {
    padding: 0
  },
  menuItem: {
    padding: 10,
    borderTop: '1px solid #DBDBDB'
  },
  menuCard: {
    boxShadow: 'none',
    width: '100%',
    borderRadius: 0
  },
  menuCnt: {
    padding: 0,
    display: 'flex',
    marginBottom: 12
  },
  menuImg: {
    width: 80,
    boxShadow:
      '0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)'
  },
  menuInfo: {
    paddingLeft: 12,
    width: 'calc(100% - 80px)'
  },
  menuName: {
    fontSize: 16,
    color: '#000000',
    marginBottom: 5,
    whiteSpace: 'normal',
    fontWeight: 'bold',
    wordBreak: 'break-all'
  },
  menuPriceCombo: {
    fontSize: 12,
    color: 'rgba(0, 0, 0, 0.54)',
    whiteSpace: 'normal',
    wordBreak: 'break-all'
  },
  menuGroupName: {
    fontSize: 12,
    fontWeight: 'bold',
    color: 'rgba(0,0,0,0.54)',
    borderRadius: 2,
    border: '1px solid #DBDBDB',
    padding: '2px 5px'
  },
  menuPrice: {
    fontSize: 14
  },
  cardActions: {
    backgroundColor: '#F7F7F7',
    justifyContent: 'center',
    padding: '0px'
  },
  marginRight10: {
    display: 'inline-block',
    marginRight: 10
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  opacity04: {
    opacity: 0.4
  },
  opacityTemp: {
    opacity: '0.4 !important'
  },
  notOpacityTemp: {
    opacity: '1 !important'
  },
  menuTypeTag: {
    display: 'inline-block',
    fontSize: 10,
    fontWeight: 'bold',
    padding: '3px 10px',
    borderRadius: 4,
    backgroundColor: '#FFFBD0',
    color: 'rgba(0, 0, 0, 0.54)',
    marginBottom: 5,
    marginRight: 5
  },
  subscriptionTag: {
    display: 'inline-block',
    fontSize: 10,
    fontWeight: 'bold',
    marginLeft: '5px',
    padding: '3px 10px',
    borderRadius: 4,
    backgroundColor: '#f12d2d',
    color: '#ffffff',
    marginBottom: 5
  },
  boxImg: {
    position: 'relative'
  },
  divMultiUsedMenu: {
    position: 'absolute',
    left: -20,
    top: -12,
    backgroundColor: '#71C9C1',
    width: 62,
    height: 33,
    transform: 'rotate(-34deg)',
    zIndex: 9
  },
  labelMultiUsedMenu: {
    position: 'absolute',
    fontSize: 9,
    fontWeight: 'bold',
    color: '#ffffff',
    left: 0,
    top: 8,
    transform: 'rotate(-34deg)',
    zIndex: 10
  },
  labelMultiUsedMenuQuantity: {
    position: 'relative',
    fontSize: 10,
    backgroundColor: '#EC4956',
    color: '#FFFB93',
    bottom: 6,
    right: -19,
    width: 57,
    textAlign: 'center',
    borderRadius: 20
  },
  expiration: {
    color: 'red'
  },
  expirationEndDate: {
    fontSize: 10,
    marginRight: 5
  },
  formControl: {
    marginLeft: 10
  },
  shashokuOption: {
    fontSize: 10,
    width: 170,
    height: 24
  },
  textDesSelect: {
    fontSize: 12,
    lineHeight: '19px',
    maxWidth: '300px',
    pointerEvents: 'none'
  },
  textFieldOption: {
    width: '100%',
    '& .MuiFormLabel-root': {
      fontSize: 14,
      fontWeight: 700,
      color: '#000'
    }
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      menus: state.gochiMenus.menus,
      totalCount: state.gochiMenus.totalCount,
      offset: state.gochiMenus.offset
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiMenus,
          getGochiMenuDetail,
          removeGochiKidMenu,
          addGochiKidMenu
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openEdit', 'updateOpenEdit', false),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openRemove', 'updateOpenRemove', false),
  withState('loading', 'updateLoading', false),
  withState('isSuccess', 'updateIsSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('menuChildType', 'setMenuChildType', 0),
  withState('comboMenu', 'setComboMenu', 0),
  withState('groupId', 'setGroupId', 0),
  withState('groupName', 'setGroupName', ''),
  withState('shopId', 'setShopId', 0),
  withState('shopName', 'setShopName', ''),
  withState('menuId', 'setMenuId', 0),
  withState('menuName', 'setMenuName', ''),
  withState('price', 'setPrice', ''),
  withState('priceCalc', 'setPriceCalc', '0 (税抜 0)'),
  withState('priceCombo', 'setPriceCombo', ''),
  withState('quantityRelease', 'setQuantityRelease', ''),
  withState('quantityPromotion', 'setQuantityPromotion', ''),
  withState('promotionDescription', 'setPromotionDescription', ''),
  withState('usageLimit', 'setUsageLimit', 0),
  withState('expiration', 'setExpiration', ''),
  withState('description', 'setDescription', ''),
  withState('expirationEndDate', 'setExpirationEndDate', ''),
  withState('taxType', 'setTaxType', 'EXTERNAL'),
  withState('taxTypeStr', 'setTaxTypeStr', '外税'),
  withState('reducedTaxCheck', 'setReducedTaxCheck', false),
  withState('reducedTaxType', 'setReducedTaxType', 'UNREDUCED'),
  withState('reducedTaxTypeStr', 'setReducedTaxTypeStr', '対象外'),
  withState('tagStr', 'setTagStr', ''),
  withState('tags', 'setTags', null),
  withState('image', 'setImage', null),
  withState('previewImage', 'setPreviewImage', null),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('createdAt', 'setCreatedAt', ''),
  withState('subscription', 'setSubscription', ''),
  withState('subscriptionInterval', 'setSubscriptionInterval', ''),
  withState('subscriptionIntervalCount', 'setSubscriptionIntervalCount', ''),
  withState('rowsPerPage', 'setRowsPerPage', 10),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('isIgnore', 'setIgnore', 0),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('page', 'setPage', 0),
  withState('textMessage', 'setTextMessage', ''),
  withState('tempShashokuOption', 'setTempShashokuOption', []),
  withState('openShashokuOption', 'updateOpenShashokuOption', 0),
  withState('shashokuOption', 'setShashokuOption', 0),
  withState('otherLanguages', 'setOtherLanguages', {}),
  withState('menuGenreId', 'setMenuGenreId', null),
  withState('menuGenreName', 'setMenuGenreName', ''),
  withState('menuSituationIds', 'setmenuSituationIds', []),
  withState('menuSituationNames', 'setMenuSituationNames', ''),
  withState('menuUserTargetIds', 'setmenuUserTargetIds', []),
  withState('menuUserTargetNames', 'setMenuUserTargetNames', ''),
  withState('menuLimitTotal', 'setMenuLimitTotal', 0),
  withState('openAdd', 'updateOpenAdd', false),
  withState('openProgress', 'updateOpenProgress', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    handleChangePage,
    listMenus,
    openDetailModal,
    updateOpenDetailModal,
    openRemove,
    updateOpenRemove,
    rowsPerPage,
    targetRowId,
    setTargetRowId,
    otherLanguages,
    setOtherLanguages,
    updateOpenEdit,
    loading,
    updateLoading,
    isSuccess,
    updateIsSuccess,
    resultMessage,
    setResultMessage,
    menuChildType,
    setMenuChildType,
    groupId,
    setGroupId,
    groupName,
    setGroupName,
    shopId,
    setShopId,
    shopName,
    setShopName,
    menuId,
    setMenuId,
    menuName,
    setMenuName,
    comboMenu,
    setComboMenu,
    price,
    setPrice,
    priceCombo,
    setPriceCombo,
    quantityRelease,
    setQuantityRelease,
    quantityPromotion,
    setQuantityPromotion,
    usageLimit,
    setUsageLimit,
    description,
    setDescription,
    promotionDescription,
    setPromotionDescription,
    expiration,
    setExpiration,
    expirationEndDate,
    setExpirationEndDate,
    taxType,
    setTaxType,
    taxTypeStr,
    setTaxTypeStr,
    reducedTaxType,
    setReducedTaxType,
    reducedTaxCheck,
    setReducedTaxCheck,
    reducedTaxTypeStr,
    setReducedTaxTypeStr,
    setSubscription,
    setSubscriptionInterval,
    setSubscriptionIntervalCount,
    subscription,
    subscriptionInterval,
    subscriptionIntervalCount,
    tags,
    setTags,
    tagStr,
    setTagStr,
    image,
    setImage,
    createdAt,
    setCreatedAt,
    updatedAt,
    setUpdatedAt,
    menuGenre,
    menuSituation,
    menuUserTarget,
    menuGenreId,
    setMenuGenreId,
    menuGenreName,
    setMenuGenreName,
    menuSituationIds,
    setmenuSituationIds,
    menuSituationNames,
    setMenuSituationNames,
    menuUserTargetIds,
    setmenuUserTargetIds,
    menuUserTargetNames,
    setMenuUserTargetNames,
    menuLimitTotal,
    setMenuLimitTotal,
    addGochiKidButton,
    openAdd,
    updateOpenAdd,
    openProgress,
    updateOpenProgress
  }) => {
    const detail = {
      menuChildType,
      groupId,
      groupName,
      shopId,
      shopName,
      menuId,
      menuName,
      price,
      description,
      comboMenu,
      priceCombo,
      subscriptionIntervalCount,
      subscriptionInterval,
      subscription,
      quantityRelease,
      quantityPromotion,
      promotionDescription,
      usageLimit,
      expiration,
      expirationEndDate,
      taxType,
      taxTypeStr,
      reducedTaxType,
      reducedTaxCheck,
      reducedTaxTypeStr,
      tags,
      tagStr,
      image,
      createdAt,
      updatedAt,
      otherLanguages,
      menuGenreName,
      menuSituationNames,
      menuUserTargetNames,
      menuGenreId,
      menuSituationIds,
      menuUserTargetIds,
      menuLimitTotal
    };

    const getGochiMenu = async id => {
      await actions.getGochiMenuDetail(id).then(detailData => {
        checkSession(detailData);
        setMenuChildType(detailData.payload.menuChildType);
        setGroupId(detailData.payload.groupId);
        setGroupName(detailData.payload.groupName);
        setShopId(detailData.payload.shopId);
        setShopName(detailData.payload.shopName);
        setMenuId(detailData.payload.menuId);
        setMenuName(detailData.payload.menuName);
        setPrice(detailData.payload.price);
        setDescription(detailData.payload.description);
        setTaxType(detailData.payload.taxType);
        setTaxTypeStr(detailData.payload.taxTypeStr);
        setReducedTaxType(detailData.payload.reducedTaxType);
        setOtherLanguages(detailData.payload.otherLanguages);
        setSubscription(detailData.payload.subscription);
        setSubscriptionInterval(detailData.payload.subscriptionInterval);
        setSubscriptionIntervalCount(
          detailData.payload.subscriptionIntervalCount
        );
        setMenuLimitTotal(detailData.payload.menuLimitTotal);
        if (detailData.payload.reducedTaxType === 'REDUCED') {
          setReducedTaxCheck(true);
          setReducedTaxTypeStr('対象');
        } else {
          setReducedTaxCheck(false);
          setReducedTaxTypeStr('対象外');
        }
        setTags(detailData.payload.tags);
        setTagStr(
          detailData.payload.tags
            .map(tag => {
              return `${tag.tagName}`;
            })
            .join(' ')
        );
        setComboMenu(detailData.payload.menuCombo);
        setPriceCombo(detailData.payload.priceCombo);
        setQuantityRelease(detailData.payload.quantity);
        setQuantityPromotion(detailData.payload.quantityFree);
        setPromotionDescription(detailData.payload.quantityFreeDes);
        setUsageLimit(detailData.payload.numberUsePerDay);
        setExpiration(detailData.payload.expiration);
        setExpirationEndDate(detailData.payload.expirationEndDate);
        setImage(detailData.payload.image);
        setCreatedAt(detailData.payload.createdAt);
        setUpdatedAt(detailData.payload.updatedAt);
        if (detailData.payload.menuGenreId) {
          setMenuGenreId(detailData.payload.menuGenreId);
          setMenuGenreName(
            menuGenre.find(
              genre =>
                genre.menuGenreId.toString() ===
                detailData.payload.menuGenreId.toString()
            ).menuGenreName
          );
        } else {
          setMenuGenreId(null);
          setMenuGenreName('');
        }

        if (
          detailData.payload.menuSituationIds &&
          detailData.payload.menuSituationIds.length
        ) {
          const userTargetNames = [];
          detailData.payload.menuUserTargetIds.forEach(userTargetId => {
            const userTargetname = menuUserTarget.find(
              userTarget =>
                userTarget.menuUserTargetId.toString() ===
                userTargetId.toString()
            ).name;
            userTargetNames.push(userTargetname);
          });
          setmenuUserTargetIds(detailData.payload.menuUserTargetIds);
          setMenuUserTargetNames(userTargetNames.join(', '));
        } else {
          setmenuUserTargetIds([]);
          setMenuUserTargetNames('');
        }
        if (
          detailData.payload.menuSituationIds &&
          detailData.payload.menuSituationIds.length
        ) {
          const situationNames = [];
          detailData.payload.menuSituationIds.forEach(situationId => {
            const situationName = menuSituation.find(
              situation =>
                situation.menuSituationId.toString() === situationId.toString()
            ).menuSituationName;
            situationNames.push(situationName);
          });
          setmenuSituationIds(detailData.payload.menuSituationIds);
          setMenuSituationNames(situationNames.join(', '));
        } else {
          setmenuSituationIds([]);
          setMenuSituationNames('');
        }
      });
    };
    // eslint-disable-next-line no-unused-vars
    const detailOpenAction = params => {
      updateLoading(true);
      updateOpenProgress(true);
      getGochiMenu(params.id)
        .then(() => {
          updateOpenProgress(false);
          updateLoading(false);
          updateOpenDetailModal(true);
        })
        .catch(error => {
          updateOpenProgress(false);
          updateLoading(false);
          console.log(error);
        });
    };

    const removeGochiKidAction = id => {
      updateOpenRemove(true);
      setTargetRowId(id);
    };
    const cancelActionRemove = () => updateOpenRemove(false);
    const removeAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const removeGochiKid = await actions
        .removeGochiKidMenu(targetRowId, { gochiKidFlag: 0 })
        .then(data => checkSession(data));
      if (removeGochiKid.type === 'REMOVE_GOCHI_KID_MENU_SUCCESS') {
        updateIsSuccess(true);
        setResultMessage('更新に完了しました。');
        updateLoading(false);
      } else {
        updateIsSuccess(false);
        setResultMessage('更新に失敗しました。もう一度やり直してください。');
        updateLoading(false);
      }
    };

    const addOpenAction = id => {
      updateOpenAdd(true);
      setTargetRowId(id);
    };
    const cancelAction = () => updateOpenAdd(false);
    const addAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const params = {
        gochiKidFlag: 1
      };
      console.log('targetRowId', targetRowId);
      const addGochiKid = await actions
        .addGochiKidMenu(targetRowId, params)
        .then(data => checkSession(data));
      if (addGochiKid.type === 'ADD_GOCHI_KID_MENU_SUCCESS') {
        updateIsSuccess(true);
        setResultMessage('更新に完了しました。');
        updateLoading(false);
      } else {
        updateIsSuccess(false);
        setResultMessage('更新に失敗しました。もう一度やり直してください。');
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isSuccess) {
        updateOpenRemove(false);
        updateOpenAdd(false);
        handleChangePage(null, 1, rowsPerPage);
      }
      updateOpenProgress(false);
      updateLoading(false);
    };

    return (
      <div>
        {listMenus && (
          <List dense={false} className={classes.lstMenu}>
            {listMenus.map((gochiMenu, index) => {
              const isMultiUsedMenu =
                gochiMenu.menuChildType === 3 || gochiMenu.menuChildType === 4;

              // const params = {
              //   id: gochiMenu.menuId
              // };

              const key = `${gochiMenu.menuId}-${gochiMenu.shopId}-${
                gochiMenu.groupName
              }`;

              const expirationDate = gochiMenu.expirationEndDate
                ? new Date(gochiMenu.expirationEndDate)
                : null;

              return (
                <ListItem
                  className={classes.menuItem}
                  key={key}
                  tabIndex={index + 1}
                >
                  <Card className={classes.menuCard}>
                    <CardContent className={classes.menuCnt}>
                      <Box className={classes.boxImg}>
                        <CardMedia
                          component="img"
                          alt={gochiMenu.menuName}
                          width="80"
                          image={gochiMenu.image || 'images/logo.png'}
                          title={gochiMenu.menuName}
                          className={[classes.menuImg]}
                        />
                        {gochiMenu.menuCombo === 1 && (
                          <>
                            <div className={classes.divMultiUsedMenu} />
                            <span className={classes.labelMultiUsedMenu}>
                              回数券
                            </span>
                          </>
                        )}
                        {gochiMenu.menuCombo === 1 &&
                          gochiMenu.quantityFree > 0 && (
                            <div className={classes.labelMultiUsedMenuQuantity}>
                              {`+`}
                              {gochiMenu.quantityFree}
                              枚無料
                            </div>
                          )}
                      </Box>
                      <Box className={classes.menuInfo}>
                        <Typography
                          gutterBottom
                          variant="h5"
                          component="h5"
                          className={[classes.menuName]}
                        >
                          {gochiMenu.menuName}
                        </Typography>
                        {gochiMenu.menuCombo === 1 && (
                          <Typography
                            gutterBottom
                            variant="h5"
                            component="h5"
                            className={[classes.menuPriceCombo]}
                          >
                            {`[${gochiMenu.priceCombo}円ｘ${
                              gochiMenu.quantity
                            }枚]`}
                          </Typography>
                        )}

                        {gochiMenu.expiration && (
                          <>
                            <Typography
                              gutterBottom
                              component="span"
                              className={[classes.expirationEndDate]}
                            >
                              利用期限
                            </Typography>
                            <Typography
                              gutterBottom
                              component="span"
                              className={[
                                classes.expiration,
                                classes.expirationEndDate
                              ]}
                            >
                              {`${gochiMenu.expiration}日間`}
                            </Typography>
                          </>
                        )}

                        {expirationDate && (
                          <>
                            <Typography
                              gutterBottom
                              component="span"
                              className={[classes.expirationEndDate]}
                            >
                              利用期間
                            </Typography>
                            <Typography
                              gutterBottom
                              component="span"
                              className={[
                                classes.expirationEndDate,
                                classes.expiration
                              ]}
                            >
                              {`${expirationDate.getMonth() +
                                1}月${expirationDate.getDate()}日まで`}
                            </Typography>
                          </>
                        )}

                        {isMultiUsedMenu && (
                          <Typography
                            gutterBottom
                            component="p"
                            className={[classes.menuGroupName]}
                          >
                            {gochiMenu.groupName}
                            {' (グループ)'}
                          </Typography>
                        )}
                        <Typography
                          gutterBottom
                          component="p"
                          className={[classes.menuPrice]}
                        >
                          {gochiMenu.price}
                          {'円'}
                        </Typography>
                        <span className={classes.menuTypeTag}>
                          {listMenuChildTypes.map(item => {
                            if (
                              parseInt(gochiMenu.menuChildType, 10) === item.id
                            ) {
                              return item.name;
                            }
                            return '';
                          })}
                        </span>
                      </Box>
                    </CardContent>

                    {!addGochiKidButton ? (
                      !gochiMenu.groupId && (
                        <CardActions className={classes.cardActions}>
                          {/* <DetailTextButton
                            params={params}
                            onClickAction={detailOpenAction}
                          /> */}
                          <RemoveGochiKidTextButton
                            id={gochiMenu.menuId}
                            readOnly={gochiMenu.readonly}
                            onClickAction={removeGochiKidAction}
                          />
                        </CardActions>
                      )
                    ) : (
                      <MenuRegisterButtonShop
                        id={gochiMenu.menuId}
                        onClickAction={addOpenAction}
                        btnText="メニュー登録"
                      />
                    )}
                  </Card>
                </ListItem>
              );
            })}
          </List>
        )}

        <Modal
          open={openDetailModal}
          onClose={() => {
            updateOpenDetailModal(false);
          }}
          className={classes.modalMobile}
        >
          <GochiMenuDetailShop
            updateOpenDetailModal={updateOpenDetailModal}
            updateOpenEditModal={updateOpenEdit}
            detail={detail}
            menuGenre={menuGenre}
            menuSituation={menuSituation}
            menuUserTarget={menuUserTarget}
          />
        </Modal>
        <AddGochiKidDialogShop
          openAdd={openAdd}
          updateOpenAdd={updateOpenAdd}
          cancelAction={cancelAction}
          addAction={addAction}
        />
        <RemoveGochiKidDialog
          openRemove={openRemove}
          updateOpenRemove={updateOpenRemove}
          cancelAction={cancelActionRemove}
          removeAction={removeAction}
          targetRowId={targetRowId}
          target=""
        />
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
